'use client'

import Image from 'next/image'
import { Button } from '@/components/ui/button'
import { useLandingAuthContext } from '@/features/landing-page/landing-auth-context'
import { LogoMarquee } from '@/features/landing-page/v3/sections/logo-marquee'
import { LpSectionHeading } from '@/features/landing-page/v3/lp-section-heading'
import { LP_GRID } from '@/features/landing-page/v3/lp-grid'

/**
 * lp-v3 "Campaigns faster" section — centered copy + CTA + a trusted-by logo marquee on one side,
 * and the pre-combined pixel-pattern brand image on the other (image on top on mobile).
 * `!` overrides the `.ds2` heading/paragraph defaults.
 */
export function LpCampaignsSection() {
    const { handleCtaClick } = useLandingAuthContext()

    return (
        <section className={`${LP_GRID.contentSection} py-[60px] md:py-[100px]`}>
            <div className="mx-auto max-w-[1320px]">
                <div className="flex flex-col-reverse gap-[60px] md:grid md:grid-cols-2 md:items-center md:gap-16">
                    {/* Copy */}
                    <div className="flex flex-col items-center text-center">
                        <Image src="/assets/landing-v3/app-icon.svg" alt="Superscale" width={64} height={64} className="size-[52px]" />

                        <LpSectionHeading line1="Campaigns as fast" line2="as pixels render" className="mt-6" />

                        <p className="mt-4 max-w-[360px] leading-[1.25]! tracking-[-0.02em]! text-muted-foreground">
                            AI marketing agents to build, launch, and iterate your campaigns
                        </p>

                        <div className="mt-8 flex items-center gap-3">
                            <Button variant="lp-primary" size="lp-lg" onClick={handleCtaClick} data-cta="get_started">
                                Start today
                            </Button>
                        </div>

                        <div className="mt-[78px] flex w-full flex-col items-center gap-4">
                            <span className="text-[16px] font-normal leading-[1.2] text-[color:var(--lp-ash)]">
                                Backed by leading investors & companies
                            </span>
                            <LogoMarquee logoHeightClass="max-h-5 md:max-h-6" gapPx={56} />
                        </div>
                    </div>

                    {/* Brand image — pixel mask + photo. The asset's ground is already baked as #FDFBF8
                        (the exact page background), so it blends seamlessly with no blend mode needed. */}
                    <Image
                        src="/assets/landing-v3/campaigns-pattern.png"
                        alt="Marketers using Superscale"
                        width={1026}
                        height={1026}
                        sizes="(max-width: 768px) 100vw, 640px"
                        className="h-auto w-full"
                    />
                </div>
            </div>
        </section>
    )
}
